<template>
    <el-container>
        <el-header>
            <el-header style="height: 30px">
                <van-nav-bar title="日报表" left-text="返回" left-arrow @click-left="historyBackPath('intebotab')"/>
            </el-header>
        </el-header>
        <el-main>
            <el-form :inline="true" size="mini">
                <el-form-item label="日期">
                    <el-date-picker style="width: 100%" value-format="yyyy-MM-dd" v-model="date" type="date" placeholder="选择日期" @change="dateChange">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <el-descriptions class="margin-top" :column="1" border>
                <el-descriptions-item>
                    <template slot="label">
                        总营业额:
                    </template>
                        {{storeDaily.totalamount}}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        总收入:
                    </template>
                    {{storeDaily.totalrevenue}}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        收定金:
                    </template>
                    {{storeDaily.djamount}}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        退定金:
                    </template>
                    {{storeDaily.backdjamount}}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        收PK金:
                    </template>
                    {{storeDaily.bonus}}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        退PK金:
                    </template>
                    {{storeDaily.backbonus}}
                </el-descriptions-item>
            </el-descriptions>
        </el-main>
    </el-container>
</template>
<script>
export default {
    data() {
        return {
            date:this.$moment().format('YYYY-MM-DD'),
            storeDaily:[],
        }
    },
    created() {
        this.getInteboPayByReport();
    },
    methods:{
        dateChange(){
            this.getInteboPayByReport();
        },
        getInteboPayByReport(){
            this.$post("inteboreport/getInteboPayByReport",{fromdate:this.date,todate:this.date}).then(res=>{
                if(res.sucess){
                    this.storeDaily=res.object;
                }
            });
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/page/intebo/intebotab/dailyreport.vue